/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  DRAFT_POST: 'DRAFT_VIDEO_CONTENT_VIDEOS',
  PUT: 'UPDATE_VIDEO_CONTENT_VIDEOS',
  DELETE: 'DELETE_VIDEO_CONTENT_VIDEOS',
  RESET: 'RESET_VIDEO_CONTENT_VIDEOS',
  RELOAD: 'RELOAD_VIDEO_CONTENT_VIDEOS',
};

export const getDraftId = () => (`videoContentVideo-draft${new Date().valueOf()}`);

export const videoContentVideosReducer = (state = [], action) => {
  switch (action.type) {
    case types.DRAFT_POST:
      return [
        ...state,
        { ...action.payload },
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.item);
      newValues.splice(index, 1);
      return newValues;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
